import React, { ReactNode } from 'react'
import { useLocation } from 'react-router-dom'
import { css } from '@emotion/core'

import { FormattedMessage } from '@divvy-web/i18n'
import BasicButton, { BASIC_BUTTON_TYPE_FILLED, BASIC_BUTTON_TYPE_FLAT } from '@divvy-web/skylab.basicbutton'
import { FormTextInput } from '@divvy-web/skylab.form'

import AutoCompleteDisable from '@sputnik/components/FormInputs/AutoCompleteDisable'
import FormElementWrapper from '@sputnik/components/FormInputs/FormElementWrapper'
import { PATHNAME_CONSTS } from '@sputnik/resources/constants'

interface AccessCodeFieldProps {
  handleResendClick: () => void
  hasError: boolean
  disabled?: boolean
  processDescription: ReactNode
}

const AccessCodeField = ({ disabled, handleResendClick, hasError, processDescription }: AccessCodeFieldProps) => {
  const { pathname } = useLocation()
  const resendButtonType =
    pathname === PATHNAME_CONSTS.VERIFY_EMAIL_PATH ? BASIC_BUTTON_TYPE_FILLED : BASIC_BUTTON_TYPE_FLAT

  return (
    <>
      <div
        className='info-text fs-unmask'
        css={accessCodeInfoTextCss}
        data-testid='email-text'
      >
        {processDescription}
      </div>
      <div className='field-container fs-unmask'>
        <FormElementWrapper
          // @ts-expect-error not fixing FormElementWrapper because it's going to get deleted
          errorCaption={
            <FormattedMessage
              defaultMessage='This access code is incorrect or expired'
              id='sputnik.AccessCodeField__kBKP+N'
            />
          }
          hasError={hasError}
        >
          <FormTextInput
            className='access-code fs-mask'
            dataTestId='access-code-field'
            inputMode='numeric'
            label={
              <FormattedMessage
                defaultMessage='Verification code'
                id='sputnik.AccessCodeField__/6gLBc'
              />
            }
            name='accessCode'
            placeholder={
              <FormattedMessage
                defaultMessage='Verification code'
                id='sputnik.AccessCodeField__/6gLBc'
              />
            }
          />
        </FormElementWrapper>
      </div>
      <AutoCompleteDisable />
      <BasicButton
        className='resend-code-link fs-unmask'
        css={resendCodeLinkCss}
        dataTestId='access-code-resend-link'
        disabled={disabled}
        type={resendButtonType}
        onClick={handleResendClick}
      >
        <FormattedMessage
          defaultMessage='Resend code'
          id='sputnik.AccessCodeField__ZD48TW'
        />
      </BasicButton>
    </>
  )
}

const accessCodeInfoTextCss = ({ mq }) => css`
  display: flex;
  margin-bottom: var(--tri-space-450);
  ${mq.xSmallMaxWidth({ marginBottom: 'var(--tri-space-550)', width: '100%' })};
`

const resendCodeLinkCss = css`
  margin-top: var(--tri-space-650);
`

export default AccessCodeField
